import { Flex, Text } from '@chakra-ui/react';
import { BaseAvatar, SelectOption } from '@invara-dev/react-base';

type Props = {
  selectOption: SelectOption;
};

/**
 * Renders a simple traveler pill with avatar and name only.
 * @param props - Component props containing selectOption with traveler data
 */
export const SimpleTravellerPill = (props: Props) => {
  const name = props.selectOption.Label;

  return (
    <Flex alignItems='center' justifyContent='center' gap={'4px'} padding={'0 4px'}>
      <BaseAvatar size={'2xs'} disableTooltip name={typeof name === 'string' ? name : ''} />
      <Text fontSize={'sm'}>{name}</Text>
    </Flex>
  );
};
